import { isElement, isEmpty, forEach } from 'lodash';

import containerManager from '../../01-helpers/filter-context/container-manager';
import { get as getPageOptions } from '../../01-helpers/utilities/options';
import { decodeBase64, encodeBase64 } from '../../01-helpers/utilities/base64';

/**
 * Filter via URL
 * 
 * {"f":"id:price_600-1000, id:9275.9229, id:9269.18662","p":1, "q":"query"}
 * 
 * 
 * * Get filters from url Hash
 * * When filters change, update url Hash
 * * URL Hash will be base64 Encoded
 * 
 **/

const moduleName = 'filter',
    selectors = {
        base: `.js-${moduleName}`
    },
    filterList = {
        f: [],
        p: 1,
        q: '',
        bb: [],
        sr: 500,
        c: []
    },
    optionNames = {
        nodeId: 'NodeId',
        page: 'Page'
    };

export default class Filter {
    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this._configure(baseElement);
        this._setup();
    }

    _bindEvents() {
        this.filterContext.onUpdate(({ currentState }) => this._onFilterChanges(currentState))

        document.addEventListener("DOMContentLoaded", () => this._onInit());
    }

    _onFilterChanges(currentState) {
        const state = currentState;
        let filterIds = [];
        //update url hash
        filterList.f = [];
        forEach(state.Filters, (filter) => {
            if (filterIds.includes(filter.Id)) {
                return false;
            }
            filterIds.push(filter.id);

            filterList.f.push(
                {
                    [filter.Id]: filter.Value
                }
            );
        });

        filterList.p = state.Page;
        filterList.q = state.SearchQuery;
        filterList.sr = state.SearchRadius;

        console.log('state', state)
        console.log('filterlist', filterList)
        if (!isEmpty(state.SearchBox)) {
            filterList.bb = [state.SearchBox.NorthEast.Latitude, state.SearchBox.NorthEast.Longitude, state.SearchBox.SouthWest.Latitude, state.SearchBox.SouthWest.Longitude];
        }
        else {
            filterList.bb = null;
        }

        if (!isEmpty(state.Center)) {
            filterList.c = [state.Center.Latitude, state.Center.Longitude];
        }
        else {
            filterList.c = null;
        }

        const hashString = JSON.stringify(filterList),
            encodedHash = encodeBase64(hashString);
        window.location.hash = `#${encodedHash}`;
    }

    _configure(baseElement) {
        this.baseElement = baseElement;
        this.filterContext = containerManager.getContainer();
        this.urlHash = window.location.hash?.substr(1);
    }

    _setup() {
        this._bindEvents();
    }

    _onInit() {
        if (isEmpty(this.urlHash)) {
            return false;
        }

        const decodedUrl = decodeBase64(this.urlHash),
            filterJson = JSON.parse(decodedUrl),
            filters = [],
            NodeId = getPageOptions(optionNames.nodeId),
            Page = filterJson.p || parseInt(getPageOptions(optionNames.page)) || 1;
            //SearchRadius = filterJson.sr;

        // find input and set filters
        forEach(filterJson.f, (filter) => {
            for (let key in filter) {
                const input = this.baseElement.querySelector(`input#${key}`),
                    type = input.parentElement.dataset?.selectionType;
                let tempFilter = {};

                switch (input.type) {
                    case 'checkbox':
                        tempFilter = {
                            'Type': type,
                            'Name': input.name,
                            'Value': input.value,
                            'Id': input.id
                        };
                        input.checked = true;
                        break;
                    case 'date':
                        tempFilter = {
                            'Type': type,
                            'Name': input.name,
                            'Value': filter[key],
                            'Id': input.id
                        };
                        input.value = filter[key];
                        break;
                    
                }
                filters.push(tempFilter);
            }
        });

        if (filterJson.q) {
            // find search box
            const searchInput = document.querySelector("input[name = 'q']");
            // set value
            searchInput.value = filterJson.q;
        }

        const filterData = {
            SearchQuery: filterJson.q || '',
            NodeId: NodeId,
            Page: Page,
            Filters: filters,
            SearchRadius: filterJson.sr || 500,
        };

        if (!isEmpty(filterJson.bb)) {
            filterData['SearchBox'] = {
                NorthEast: {
                    Latitude: filterJson.bb[0],
                    Longitude: filterJson.bb[1]
                },
                SouthWest: {
                    Latitude: filterJson.bb[2],
                    Longitude: filterJson.bb[3]
                }
            };
        }

        if (!isEmpty(filterJson.c)) {
            filterData['Center'] = {                
                Latitude: filterJson.c[0],
                Longitude: filterJson.c[1]                
            };
        }

        this.filterContext.update(
            filterData,
            { refresh: true }
        );
    }
}

const initFilter = () => {
    forEach(document.querySelectorAll(selectors.base), (filterElement) => {
        new Filter(filterElement);
    });
};

initFilter();